export function memoListGet(text, page) {
	return {
    type: 'MEMO_LIST_GET',
		payload: {
			text: text, 
			page: page,
		},
	}
}

export function memoListEdit(pic, text) {
	return {
    type: 'MEMO_LIST_EDIT',
		payload: {
			pic: pic,
			text: text,
		},
	}
}
